import { render, staticRenderFns } from "./PlacesView.vue?vue&type=template&id=3b97a03c"
import script from "./PlacesView.vue?vue&type=script&lang=js"
export * from "./PlacesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports